module.exports = __webpack_public_path__ + "img/center-info-structure3.73b77885.png";